import { useResellerReport } from '../../../Hooks/useResellerReport';
import './ImportError.scss';
import vector_btn from '../../../Assets/images/svg/Vector.svg';
const ImportError = () => {
  const { importError, setImportError } = useResellerReport();

  const onIconClick = () => {
    setImportError('');
  };

  return (
    importError !== '' && (
      <div className="import-error">
        <p className="import-error-msg">
          <img src={vector_btn} alt="Error Icon" className="error-icon" />
          <span>
            {importError}
          </span>
        </p>
        <button className='button-unset' onClick={onIconClick}>
          <i className="pi pi-times" ></i></button>
      </div>
    )
  );
};

export default ImportError;
